import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-65db90ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Tienda", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Recuerda que comprando a través de los enlaces estas contribuyendo al mantenimiento de la plataforma.", -1))
const _hoisted_4 = { class: "tbody" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["href"]
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/articulo",
  class: "btn-details"
}, " Ver Detalles ", -1))
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/articulo",
  class: "btn-details"
}, " Ver Detalles ", -1))

import DefaultLayout from '@/layouts/DefaultLayout.vue';
  import Navbar from '@/components/layouts/NavBar.vue';
  import { Ref,ref,onMounted } from 'vue';
  import ShopService from '@/services/ShopService'
  import ShopInterface from '@/interfaces/ShopInterface';

  

  
export default /*#__PURE__*/_defineComponent({
  __name: 'GeneralShopView',
  setup(__props) {

  const loading: Ref<boolean> = ref(false)
  const service = new ShopService()
  const category = ref([])
  const features: Ref<Array<ShopInterface>> = ref([])

  onMounted(async()=>{
    loading.value = true
    category.value = await service.ListAllCategories()
    features.value = await service.ListAllFeaturedItems()
    loading.value = false
})

  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createVNode(Navbar),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(features.value, (elm) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "card",
              key: elm.id
            }, [
              _createElementVNode("img", {
                src: elm.image_uri,
                alt: "img prueba",
                width: "200",
                height: "210"
              }, null, 8, _hoisted_5),
              _createElementVNode("h5", null, _toDisplayString(elm.title), 1),
              _createElementVNode("p", null, _toDisplayString(elm.price) + " € ", 1),
              _createElementVNode("a", {
                href: `/articulo/${elm.id}`,
                class: "btn-details"
              }, " Ver Detalles ", 8, _hoisted_6)
            ]))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(features.value, (elm) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "card",
              key: elm.id
            }, [
              _createElementVNode("img", {
                src: elm.image_uri,
                alt: "img prueba",
                width: "200",
                height: "210"
              }, null, 8, _hoisted_7),
              _createElementVNode("h5", null, _toDisplayString(elm.title), 1),
              _createElementVNode("p", null, _toDisplayString(elm.price) + " € ", 1),
              _hoisted_8
            ]))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(features.value, (elm) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "card",
              key: elm.id
            }, [
              _createElementVNode("img", {
                src: elm.image_uri,
                alt: "img prueba",
                width: "200",
                height: "210"
              }, null, 8, _hoisted_9),
              _createElementVNode("h5", null, _toDisplayString(elm.title), 1),
              _createElementVNode("p", null, _toDisplayString(elm.price) + " € ", 1),
              _hoisted_10
            ]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }))
}
}

})